import { FC } from 'react';
import { AvailabilityMetricsProps } from './AvailabilityMetrics.types';
import {
  Container,
  MetricsGrid,
  MetricCard,
  MetricIcon,
  MetricValue,
  MetricValueLabel,
} from './AvailabilityMetrics.styles';
import { AllieText } from '../../../../../components/Text';
import { AllieBanOutlineIcon, AllieCalendarIcon, AllieHourglassOutlineIcon } from '../../../../..';

export const AvailabilityMetrics: FC<AvailabilityMetricsProps> = ({
  downtime,
  availableTime,
  mostStoppedMachine,
  labels,
  isEmpty,
}) => {
  return (
    <Container>
      <AllieText type="body1" weight={500}>
        {labels.title}
      </AllieText>
      <MetricsGrid>
        <MetricCard>
          <MetricIcon>
            <AllieHourglassOutlineIcon />
          </MetricIcon>
          <MetricValueLabel>
            <AllieText type="body2" color="neutral-60">
              {labels.downtime}
            </AllieText>
            <MetricValue>
              <AllieText type="h4" color="neutral-90">
                {isEmpty ? labels.withoutData : downtime}
              </AllieText>
            </MetricValue>
          </MetricValueLabel>
        </MetricCard>

        <MetricCard>
          <MetricIcon>
            <AllieCalendarIcon />
          </MetricIcon>
          <MetricValueLabel>
            <AllieText type="body2" color="neutral-60">
              {labels.availableTime}
            </AllieText>
            <AllieText type="h4" color="neutral-90">
              {isEmpty ? labels.withoutData : availableTime}
            </AllieText>
          </MetricValueLabel>
        </MetricCard>

        <MetricCard>
          <MetricIcon>
            <AllieBanOutlineIcon />
          </MetricIcon>
          <MetricValueLabel>
            <AllieText type="body2" color="neutral-60">
              {labels.mostStoppedMachine}
            </AllieText>
            <MetricValue>
              {mostStoppedMachine ? (
                <>
                  <AllieText type="h4" color="neutral-90" lineClamp={2}>
                    {mostStoppedMachine.name}
                  </AllieText>
                  <AllieText type="body2" weight={500} color="neutral-60">
                    {` (${mostStoppedMachine.hours})`}
                  </AllieText>
                </>
              ) : (
                <AllieText type="h4" color="neutral-90">
                  {isEmpty ? labels.withoutData : '-'}
                </AllieText>
              )}
            </MetricValue>
          </MetricValueLabel>
        </MetricCard>
      </MetricsGrid>
    </Container>
  );
};
